import React from "react";
import "./Loader.css";

const Loader: React.FC = () => {
  return (
    // <div className="loader-container">
    //   <div className="bar">
    //     <div className="fill"></div>
    //   </div>
    //   <div className="bar">
    //     <div className="fill"></div>
    //   </div>
    //   <div className="bar">
    //     <div className="fill"></div>
    //   </div>
    //   <div className="bar">
    //     <div className="fill"></div>
    //   </div>
    //   <div className="bar">
    //     <div className="fill"></div>
    //   </div>
    // </div>
    <div className="loader"></div>
  );
};

export default Loader;
